import { CARD_TYPES } from '../../../../constants/card'
import { tenantIds } from '../../../../constants/tenantIds'

export class CardValidators {
  static translator

  static get l10n() {
    if (!this.translator) {
      throw new Error('Translation function is not defined')
    }

    return this.translator
  }

  static setTranslator(translator) {
    this.translator = translator
  }

  static checkProhibitedCardBrands(prohibitedCardBrands, cardBrand, tenantId) {
    const l10n = this.l10n
    return value => {
      const cardNumber = value.replace(/\s/g, '')
      if (cardNumber.length >= 4) {
        if (prohibitedCardBrands?.includes(cardBrand)) {
          if (
            cardBrand.toLowerCase() === CARD_TYPES.maestro &&
            tenantId === tenantIds.ATCOM
          ) {
            return l10n.t(
              'Maestro cards cannot be accepted for Contact Centre/Homeworker payments, please use a different card',
            )
          }

          return l10n.t(
            'Sorry, this card is not accepted, please use a different card',
          )
        }

        if (
          prohibitedCardBrands?.includes('GiftCard') &&
          cardBrand === 'Omnio'
        ) {
          return l10n.t('CARD_EXPIRY_DATE_INVALID')
        }
      }

      return true
    }
  }

  static isCardValid = value => {
    const l10n = this.l10n
    const cardNumber = value.replace(/\s/g, '')
    const pattern = /^[0-9\W]{12,19}$/
    if (!pattern.test(cardNumber)) {
      return l10n.t('Please enter the full 12-19 digit card number')
    }
  }

  static luhnAlgorithmCheck = value => {
    const l10n = this.l10n

    const cardNumber = value.replace(/\s/g, '')

    // Skip Luhn validation for OMNIO cards
    if (cardNumber.startsWith('40006506')) {
      return null
    }

    let nCheck = 0
    let bEven = false
    let message = null

    for (let n = cardNumber.length - 1; n >= 0; n--) {
      const cDigit = cardNumber.charAt(n)
      let nDigit = parseInt(cDigit, 10)

      if (bEven) {
        // eslint-disable-next-line no-cond-assign
        if ((nDigit *= 2) > 9) {
          nDigit -= 9
        }
      }

      nCheck += nDigit
      bEven = !bEven
    }

    if (nCheck % 10 !== 0) {
      message = l10n.t('Please enter valid card number')
    }

    return message
  }
}
